__turbopack_context__.v({
  "arrow": "contributor-module__ZGMLDW__arrow",
  "authorIcon": "contributor-module__ZGMLDW__authorIcon",
  "bookCardContainer": "contributor-module__ZGMLDW__bookCardContainer",
  "bookCount": "contributor-module__ZGMLDW__bookCount",
  "center": "contributor-module__ZGMLDW__center",
  "contibutorDesc": "contributor-module__ZGMLDW__contibutorDesc",
  "contibutorHeading": "contributor-module__ZGMLDW__contibutorHeading",
  "contibutorImage": "contributor-module__ZGMLDW__contibutorImage",
  "contributorDetail": "contributor-module__ZGMLDW__contributorDetail",
  "contributorSection": "contributor-module__ZGMLDW__contributorSection",
  "relatedPost": "contributor-module__ZGMLDW__relatedPost",
  "relatedPostSection": "contributor-module__ZGMLDW__relatedPostSection",
  "topPadding": "contributor-module__ZGMLDW__topPadding",
});
